import { useEffect, useRef } from 'react';

// AdSense Ad Unit Component
const AdBanner = ({ 
  slot = "auto", 
  format = "auto", 
  responsive = true,
  className = "" 
}) => {
  const adRef = useRef(null);
  const isAdLoaded = useRef(false);

  useEffect(() => {
    // Only load ad once per component instance
    if (isAdLoaded.current) return;
    
    try {
      // Check if adsbygoogle is available
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        isAdLoaded.current = true;
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div className={`ad-container my-4 ${className}`} data-testid="ad-banner">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8435418941598763"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
      <p className="text-[10px] text-center text-muted-foreground mt-1">Publicité</p>
    </div>
  );
};

// In-Feed Ad Component (between posts)
export const InFeedAd = ({ className = "" }) => {
  const adRef = useRef(null);
  const isAdLoaded = useRef(false);

  useEffect(() => {
    if (isAdLoaded.current) return;
    
    try {
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        isAdLoaded.current = true;
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div className={`ad-container bg-muted/30 rounded-xl p-4 my-4 ${className}`} data-testid="in-feed-ad">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8435418941598763"
        data-ad-slot="auto"
        data-ad-format="fluid"
        data-ad-layout-key="-6t+ed+2i-1n-4w"
      />
      <p className="text-[10px] text-center text-muted-foreground mt-2">Sponsorisé</p>
    </div>
  );
};

export default AdBanner;
